import "./src/style/global/bootstrap.min.css"
import SwaggerUI from "swagger-ui"
window.SwaggerUI = SwaggerUI
